import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import Footer from "@qlik/qlik/src/components/Footer";
import Header from "@qlik/qlik/src/components/Header";
import NotificationBar from "../NotificationBar";
import { useAppContext } from "@qlik/qlik/src/context/AppContext";
import { PageListProvider } from "@qlik/utils/pageListContext";
import { HeaderContext, useHeaderContext } from "@qlik/qlik/src/context/HeaderContext";

/**
 * Layout component
 * This component is used to wrap the main content of the page.
 * It includes the Header and Footer components, and uses Suspense to handle loading states.
 * @param {Object} props - The component props
 * @param {ReactNode} props.children - The main content to be wrapped
 * @param {Object} props.headerData - The data for the Header component
 * @param {Object} props.footerData - The data for the Footer component
 * @param {string} props.pageSlug - The slug of the current page
 */
const Layout = ({
    children,
    headerData,
    footerData,
    pageSlug,
    dynamicHeaderCta,
    headerType,
    footerType,
    searchPopupData,
}) => {
    // Check if site is being scrolled
    const { siteScrolledDown } = useAppContext();

    // Create an array of classes to be passed to the main element
    let mainClasses = [
        siteScrolledDown ? "xl:-translate-y-8" : "xl:translate-y-0",
        "xl:transition-transform xl:duration-300",
    ];

    // Join the mainClasses array into a string
    mainClasses = mainClasses.join(" ");

    // Pass a list of all site pages to the page list provider.
    const { allSitePage, allCustomRedirect } = useStaticQuery(graphql`
        query {
            allSitePage {
                nodes {
                    path
                }
            }
            allCustomRedirect {
                nodes {
                    fromPath
                    toPath
                    force
                }
            }
        }
    `);

    const headerContext = useHeaderContext();

    // Render the layout
    return (
        <PageListProvider allSitePage={allSitePage} allCustomRedirect={allCustomRedirect}>
            <HeaderContext.Provider value={headerContext ?? "header"}>
                <Header
                    data={{ ...headerData, dynamicHeaderCta, searchPopupData }}
                    pageSlug={pageSlug}
                    headerType={headerType}
                />
            </HeaderContext.Provider>
            <main className={`${mainClasses} `}>{children}</main>
            <Footer data={footerData} footerType={footerType} className={footerType !== "Minimal" ? mainClasses : ""} />
        </PageListProvider>
    );
};

// Export the Layout component
export default Layout;
